enum DialogMode {
  CREATE = 1,
  EDIT = 2,
  VIEW = 3,
  DELETE = 4
}

export default DialogMode;
